import type {PageRouteConfig} from '@router';

import VendorRegisterOverview from 'modules/VendorRegisterOverview/VendorRegisterOverview';

export function createVendorRegisterOverviewRoute(): PageRouteConfig {
  return {
    element: <VendorRegisterOverview />,
    layout: {
      title: 'مراحل ثبت نام',
      hasNavigate: false,
      hasHeader: false,
      hasBack: false,
      hasLeftIcon: false
    }
  };
}
